module.exports = __webpack_public_path__ + "img/waspada_odp.cb939ef9.png";